<app-header></app-header>
<app-home-page></app-home-page>
<app-top-rated-mutual-funds></app-top-rated-mutual-funds>
<app-why-choose-us></app-why-choose-us>
<app-testimonial></app-testimonial>
<app-partners></app-partners>
<app-how-it-works></app-how-it-works>
<app-features></app-features>
<app-footer></app-footer>
